import React, {useState, useEffect} from "react";
import {useForm} from 'react-hook-form'
import { toast } from "react-toastify";
import api from "../../../api/api";


const VatUpdate = ({ VatId,setchange, change }) => {
  const { register, handleSubmit, unregister, setValue } = useForm();
  const [results, setResults] = useState([])
 useEffect(()=> {
    
        api.get(`/services/vat-entry/?id=${VatId}`)
        .then(response=> {
            console.log("vatlist cons",response.data)
            setResults(response.data)
        
        }).catch(error=> {
            console.log(error)
        })
    
   
 },[VatId])

  const handleSub = (data) => {
    // console.log(data)
    api.patch(`/services/vat-entry/${VatId}/`, data)
    .then(response=> {
        setchange(!change)
        toast.success("Updated Successfully")
    }).catch(error=> {
        toast.error("Unable to Update")
    })
  }

  return (
    <div
      className="modal fade fixed top-0 left-0 hidden h-full w-full overflow-y-auto overflow-x-hidden outline-none"
      id="VatModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-lg pointer-events-none relative w-auto">
        <div className="modal-content pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none">
          <div className="flex justify-end">
            <svg
              data-bs-dismiss="modal"
              aria-label="Close"
              className="text-primary-blue h-8 w-8"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              role="img"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42Z"
              />
            </svg>
          </div>
          <div className="modal-header rounded-t-md border-b border-gray-200 p-4">
            {/*Vat Update */}
            <div className=" px-10">
              <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
                Udpdate VAT Entry Report
              </h1>
              <div className="">
                <img
                  src="../../images/title-border.png"
                  alt=""
                  className="mx-auto mt-4"
                />
              </div>

              <form onSubmit={handleSubmit(handleSub)}>
                <div style={{ width: 400 }}>
                  {/* <ReactSearchAutocomplete
                    placeholder="search"
                    items={searchData}
                    onSearch={handleOnSearch}
                    onHover={handleOnHover}
                    onSelect={handleOnSelect}
                    onFocus={handleOnFocus}
                    autoFocus
                    formatResult={formatResult}
                  /> */}
                </div>
                <div className="grid md:grid-cols-2  grid-cols-1 border-2 border-primary-blue font-bold mt-3">
                  <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
                    <label>Month</label>
                    <select
                      className="text-primary-blue"
                      {...register("month", { required: false },
                      setValue('month', results[0]?.month)

                      )
                    }
                    >
                      <option>Select</option>
                      {/* <option>{results[0]?.month}</option> */}
                      <option value="baisakh">Baisakh</option>
                      <option value="jestha">Jestha</option>
                      <option value="ashad">Ashad</option>
                      <option value="shrawan">shrawan</option>
                      <option value="bhadra">bhadra</option>
                      <option value="ashwin">Ashwin</option>
                      <option value="kartik">Kartik</option>
                      <option value="mangsir">Mangsir</option>
                      <option value="poush">Poush</option>
                      <option value="magh">Magh</option>
                      <option value="falgun">Falgun</option>
                      <option value="chaitra">Chaitra</option>
                    </select>
                  </div>

                  <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
                    <label>Year</label>
                    <br />
                    <input
                      className="text-primary-blue"
                      type="text"
                      placeholder="Year"
                      {...register("year", { required: false },
                      setValue('year', results[0]?.year)
                      )}
                    />
                  </div>
                  <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
                    <label>Start Date</label>
                    <br />
                    <input
                      type="date"
                      className="text-primary-blue"
                      {...register("start_date", { required: false },
                      setValue('start_date', results[0]?.start_date)
                      )}
                    />
                  </div>

                  <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
                    <label>End Date</label>
                    <br />
                    <input
                      type="date"
                      className="text-primary-blue"
                      {...register("end_date", { required: false },
                      setValue('end_date', results[0]?.end_date)
                      )}
                    ></input>
                  </div>

                  <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
                    <label>Company Name</label>
                    <input
                      type="text"
                      placeholder="Company Name"
                      className="text-primary-blue"
                      {...register(
                        "company_name",
                        { required: false },
                        setValue('company_name', results[0]?.company_name)
                      )}
                      //  defaultValue={results?.company_name ? results.company_name : ''}
                    />
                  </div>

                  <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
                    <label>Company Address</label>
                    <input
                      type="text"
                      placeholder="Company Address"
                      className="text-primary-blue"
                      {...register(
                        "company_address",
                        { required: false },
                        setValue('company_address', results[0]?.company_address)
                      )}
                      // defaultValue={results?.company_address ? results.company_address: "" }
                    />
                  </div>

                  <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
                    <label>Company Contact Person</label>
                    <input
                      type="text"
                      placeholder="Company Contact Person"
                      className="text-primary-blue"
                      {...register("company_contact_person", {
                        required: false,
                      },
                      setValue('company_contact_person',results[0]?.company_contact_person )
                      )}
                    //   defaultValue={
                    //     results?.contact_person ? results.contact_person : ""
                    //   }
                    />
                  </div>

                  <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
                    <label>Company Contact Number</label>
                    <input
                      type="text"
                      placeholder="Company Contact Number"
                      className="text-primary-blue"
                      {...register("company_contact_number", {
                        required: false,
                      },
                      setValue('company_contact_number',results[0]?.company_contact_number )
                      )}
                    //   defaultValue={
                    //     results?.conatact_number ? results.conatact_number : ""
                    //   }
                    />
                  </div>

                  <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
                    <label>Company PAN Number</label>
                    <input
                      type="text"
                      placeholder="Company PAN Number"
                      className="text-primary-blue"
                      {...register("company_pan_vat", { required: false },
                      setValue('company_pan_vat', results[0]?.company_pan_vat)
                      )}
                    />
                  </div>

                  <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
                    <label>Remarks</label>
                    <input
                      type="text"
                      placeholder="Remarks"
                      className="text-primary-blue"
                      {...register("remarks", { required: false },
                      setValue('remarks', results[0]?.remarks)
                      )}
                    />
                  </div>

                  <div className="flex   p-3  border-r border-primary-blue items-center gap-3 text-red-600">
                    <label>Status</label>
                    <select
                      className="text-primary-blue"
                      {...register("status", { required: false },
                      setValue('status', results[0]?.status)
                      )}
                    >
                      <option>Select</option>
                      <option value="pending">Pending</option>
                      <option value="processing">Processing</option>
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>

                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                

                  className=" bg-primary-blue text-white text-base p-2 rounded-2xl mt-3"
                >
                  Submit
                </button>
              </form>
            </div>

            {/* close */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VatUpdate;
